import * as React from 'react';
import moment from 'moment';
import Table from 'rc-table';

import '@app/scss/components/bookNowCard.scss';

interface BookNowCardProps {
	name: string;
	departureDate: number;
	startLocation?: string;
	finalLocation?: string;
	ratesInfo: Array<Record<string, React.ReactNode>>;
}

const postscript = `Travel insurance is an optional per person rate based on age and trip cost. Rate above is for individuals
aged between 61-65. * Government taxes and fuel surcharges may vary.`;

function getColumns(columnsNames: Array<{ name: string; key: string }>) {
	return columnsNames.map((item) => {
		return {
			title: item.name,
			dataIndex: item.key,
			key: item.key,
		};
	});
}

const columns = [
	{
		name: 'Cabin',
		key: 'cabin',
	},
	{
		name: 'Category',
		key: 'category',
	},
	{
		name: 'Tax*',
		key: 'tax',
	},
	{
		name: 'Fuel Surcharge*',
		key: 'fuelSurcharge',
	},
	{
		name: 'Total per Person',
		key: 'pricePerson',
	},
	{
		name: 'Total per Cabin',
		key: 'priceCabin',
	},
	{
		name: 'Travel Insurance',
		key: 'priceInsurance',
	},
];

export const BookNowCard = (props: BookNowCardProps) => {
	const departureDate = moment(props.departureDate).format('MMMM DD, YYYY');
	const tableColumns = props.ratesInfo.some((item) => item.action)
		? [...columns, { name: '', key: 'action' }]
		: columns;

	return (
		<div className="book-now font-family_primary text-size_small">
			<div className="col-12 content-halign_center">
				<h3 className="font-family_decorative text-size_medium content-valign_center">Rates & Availability for</h3>
				<h1 className="text-size_large line-height_large book-now__title">{props.name}</h1>
				<div className="layout-container book-now__departure-block font-weight_bold">
					<p className="col-12 col-xs-4 content-halign_center">
						Departure Date: <i className="font-weight_regular">{departureDate}</i>
					</p>
					<p className="col-12 col-xs-4 content-halign_center  book-now__start-location">
						Starting Location: <i className="font-weight_regular">{props.startLocation}</i>
					</p>
					<p className="col-12 col-xs-4 content-halign_center">
						Final Destination: <i className="font-weight_regular">{props.finalLocation}</i>
					</p>
				</div>
				<h2 className="text-size_large line-height_large book-now__subtitle">{`Rates for ${departureDate}`}</h2>
				<div className="book-now__table-wrap">
					<Table
						columns={getColumns(tableColumns)}
						data={props.ratesInfo}
						className="book-now__table"
					/>
				</div>

				<p className="text-size_extra-small">{postscript}</p>
			</div>
		</div>
	);
};
